import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/services/auth.service';
import { KeycloakService } from '../services/keycloak.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private keycloak: KeycloakService,
    private router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Use state.url not router.url — fresh tab on /auth/reset/... has router.url === '/'
    if (state.url.includes('/auth/reset/')) {
      return true;
    }

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
      return false;
    }

    if (this.keycloak.enabled && !this.keycloak.authenticated) {
      this.keycloak.login();
      return false;
    }

    // KC-authenticated users must never see the legacy form either: its
    // json_login checks the DB hash, which rejects KC-managed passwords
    // ("Invalid credentials" with the correct password). Send them to the
    // root redirect instead; if their account data fails to load there,
    // RootRedirectService logs the stale session out for a clean re-login.
    if (this.keycloak.enabled && this.keycloak.authenticated) {
      this.router.navigate(['/'], { replaceUrl: true });
      return false;
    }

    return true;
  }
}
